import { Subject } from 'rxjs';

const subject = new Subject();

export const commentTopicService = {
  emitReload: val => subject.next(val),
  reload: () => subject.asObservable()
};